import { Typography } from "@mui/material";
import { formatWeekdayDate } from "@shared";

import { useLanguageContext } from "@/common/contexts/language-context/LanguageContext";
import { locales } from "@/common/contexts/localization-date-context/LocalizationDateContextProvider.utils";

interface Props {
  date: Date;
  /** 2 = primary group with a rule underneath, 3 = sub-group inside a court. */
  level: 2 | 3;
  id?: string;
}

/** "Montag, 27.07.2026" as a group heading. */
export function DayGroupHeading({ date, level, id }: Props) {
  const { language } = useLanguageContext();
  const label = formatWeekdayDate(date, locales[language]);

  if (level === 2) {
    return (
      <Typography id={id} variant="h4" component="h2" sx={{ pb: 1, borderBottom: 1, borderColor: "divider" }}>
        {label}
      </Typography>
    );
  }

  return (
    <Typography id={id} variant="subtitle1" component="h3" fontWeight={700}>
      {label}
    </Typography>
  );
}
